import React, { FC } from 'react';
import { AvatarGroupDefaultItem } from '@carnica/ui-kit/types';
import { defineUrlIcon } from '@carnica/graphics';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

type IconListProps = {
  logos: AvatarGroupDefaultItem[];
};

export const IconList: FC<IconListProps> = ({ logos }) => {
  return (
    <div className={cn('group')}>
      {logos?.map((logo, index) => {
        const Icon = defineUrlIcon({
          url: logo,
          multiColor: false,
          defaultSize: 16,
          ratio: 1,
        });
        return <Icon className={cn('icon')} key={index} />;
      })}
    </div>
  );
};
